<div class="form-section" [formGroup]="form">
  <core-form-select
    data-cy="field-datelang-language"
    label="Language"
    i18n-label
    formControlName="lang"
    [options]="langOptions"
  ></core-form-select>

  <core-form-select
    data-cy="field-datelang-dateformat"
    label="Date format"
    i18n-label
    formControlName="locale"
    [options]="localeOptions"
  ></core-form-select>
</div>
